import React, { useEffect, useState } from "react";
import HeaderOS1 from "./HeaderOS1";
import "./FormularioStyle.css"
import { useNavigate, useSearchParams } from "react-router-dom";
import ServiceBackend from "../Services/ServiceBackend"
import configSecc from "../Services/config.json";
import CanvasDraw from "react-canvas-draw";
import { useRef } from "react";
import ModalStyles from "./ModalStyles.module.css";
import { Modal, ModalBody, ModalHeader, Label, ModalFooter, Button, Spinner} from "reactstrap";
import ModalFirmaData from "./Common/ModalFirmaData";
import ModalFirmaPie from "./Common/ModalFirmaPie";


const Done = () => {

    const [date, setDate] = useState(new Date());
    const iniDate =  new Date(date);
  
    function refreshClock() {
        window.location=(configSecc.urlRedirect)
    }
    useEffect(() => {
      const timerId = setInterval(refreshClock, 1000 * 3);
      return function cleanup() {
        clearInterval(timerId);
      };
    }, []);
   
    const handleRedirect = () => {
       window.location=(configSecc.urlRedirect)
    }

    const setCurrent = () =>{
    }
    
   
    useEffect(()=>{

    },[])

    
   
   
    return(
        <>
       
       <div className="container-fluid margin20 needs-validation">
       <h1>&nbsp;</h1>
       <h1 className="bd-content-title alignCenter">
            Felicitaciones!! Te has registrado correctamente.
        </h1>

    <h3>
            &nbsp;
        </h3>
        <h3 className="bd-content-title alignCenter">
            En 3 segundos serás redireccionado nuevamente.
        </h3>


        <h3>
            &nbsp;
        </h3>      
        <div className="row">
        <div className="col formTitle1">
            <input type="submit" className="btn btn-primary btnEnviar" value="Ir" onClick={handleRedirect}/> </div>
    </div>
    

    


   </div>
   


    


    </>);
}

export default Done;